export default {"src":"/_next/static/image/public/images/ic_location_vertical_menu.efa00298499a8ebf0bf19f990fc95c77.svg","height":20,"width":20};